import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-warning-client-questionnaire-already-submitted',
  templateUrl: './warning-client-questionnaire-already-submitted.component.html',
  styleUrls: ['./warning-client-questionnaire-already-submitted.component.scss'],
  standalone: false,
})
export class WarningClientQuestionnaireAlreadySubmittedComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
